module.exports = __webpack_public_path__ + "static/media/ios-add.2cb95301.svg";